import styles from './Credits.module.css'
import CreditsIcon  from '../../../assets/credits-primary.svg?react'
import Close  from '../../../assets/close.svg?react'
import { useTranslation } from 'react-i18next'
import { useConfigTexts } from '../../../hooks/config-texts'

interface Props {
  openCredits: boolean
  setOpenCredits: (openCredits: boolean) => void
}

export default function Credits({ openCredits, setOpenCredits }: Props) {
  const { t } = useTranslation()
  const { data: texts } = useConfigTexts()

  return (
    <div
      className={styles.WikiLoveMonuments}
      style={{
        opacity: openCredits ? '1' : '0',
        pointerEvents: openCredits ? 'all' : 'none',
        transition: 'all 0.5s ease-in-out',
      }}
    >
      <div className={styles.TopWikiLove}>
        <div className={styles.WikiLoveLabel}>
          <CreditsIcon />
          <span className="ms-2">{t('GENERIC_CREDITS')}</span>
        </div>
        <div className="pointer">
          <Close onClick={() => setOpenCredits(false)} />
        </div>
      </div>
      <div className="mt-4">
        <div
          className={styles.CreditsText}
          dangerouslySetInnerHTML={{ __html: texts ? texts[0]?.testo_credits || '' : '' }}
        ></div>
      </div>
    </div>
  )
}
